import styled from 'styled-components';

const InfoCreditBannerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  width: 100%;
  border-image: linear-gradient(to left, #ed1e79 0%, #451287 100%) 1;
  border-top: 4px solid transparent;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(45, 18, 65, 0.15);
  margin-bottom: 16px;
`;

const InfoCreditTop = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;

  p {
    font-size: 16px;
  }
`;
const InfoCreditBottom = styled.div`
  background: #eff1f3;
  padding: 8px 16px;
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #c9cfd7;

  p {
    font-size: 14px;
    text-align: left;
    margin-right: 2px;
    margin-bottom: 6px;
    line-height: 20px;
    display: inline;

    @media (max-width: 768px) {
      ${({ showInfo }) => showInfo && 'display: inline-block;'}
      margin: 12px 0;
    }
  }
`;

const ShowMore = styled.span`
  color: #400781;
  font-size: 14px;
  width: 138px;
  border-bottom: 1px solid #400781;
  cursor: pointer;
  display: ${props => (props.showInfo ? 'block' : 'inline')};
  padding-bottom: 1px;
  font-weight: 700;
`;
export { InfoCreditTop, InfoCreditBannerWrapper, InfoCreditBottom, ShowMore };
